import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IProfileStrings extends LocalizedStringsMethods {
    lsHomeTxt: string;
    lsProfilesTxt: string;
    lsAddProfileTxt: string;
    lsUpldProfileTxt: string;
    lsDnwldProfileTxt: string;
    lsExportProfileOkTxt: string;
    lsExportProfileSuccessTxt: string;
    lsProfilePrintTxt: string;
    lsViewProfilesTxt: string;
    lsNoFilterTxt: string;
    lsClearFilterTxt: string;
    lsProfileFNameTxt: string;
    lsProfileMNameTxt: string;
    lsProfileLNameTxt: string;
    lsProfileIDTxt: string;
    lsProfileGenderTxt: string;
    lsDateRangeTxt: string;
    lsTestDateTxt: string;
    lsProfileLevelTxt: string;
    lsProfileConussionTxt: string;
    lsProfileNotifyEmailsTxt: string;
    lsProfileNotifyPhonesTxt: string;
    lsOrgTxt: string;
    lsOrgsTxt: string;
    lsManageUsrTxt: string;
    lsManageOrgTxt: string;
    lsProfilePrintSelectTxt: string;
    lsProfilePrintWithTestTxt: string;
    lsProfilePrintWithoutTestTxt: string;
    lsProfileListPrintTxt: string;
    lsCSVTxt: string;
    lsEditTxt: string;
    lsIDTxt: string;
    lsViewProfileSportTxt: string;
    lsViewProfileBDayTxt: string;
    lsViewProfileGenderTxt: string;
    lsViewProfileBaselineTxt: string;
    lsViewProfileTotalTestTxt: string;
    lsViewProfileContactInfoTxt: string;
    lsViewProfileEmailTxt: string;
    lsViewProfilePhoneTxt: string;
    lsViewProfileNotifyEmailTxt: string;
    lsViewProfileNotifyPhonesTxt: string;
    lsViewProfileTestHistoryTxt: string;
    lsViewProfileShareTextTxt: string;
    lsViewProfilePrintTxt: string;
    lsViewProfileDownloadTxt: string;
    lsViewProfileExportTxt: string;
    lsViewProfileOkTxt: string;
    lsViewProfileTestExportSuccessTxt: string;
    lsViewProfileTestSharedSuccessTxt: string;
    lsViewProfileTestShareFailTxt: string;
    lsProfileListFilterTxt: string;
    lsFilterTxt: string;
    lsOkTxt: string;
    lsBaselineTxt: string;
}

let strings: IProfileStrings;
export default strings = new LocalizedStrings({
    en: {
        lsHomeTxt: 'Home',      
        lsProfilesTxt: 'Profiles',
        lsAddProfileTxt: 'Add Profile',
        lsUpldProfileTxt: 'Upload New Profiles',
        lsDnwldProfileTxt: 'Download',
        lsExportProfileOkTxt: 'Ok',
        lsExportProfileSuccessTxt: 'Profiles exported successfully without tests!',
        lsProfilePrintTxt: 'Print',
        lsViewProfilesTxt: 'View Profiles',
        lsNoFilterTxt: 'No filters applied',
        lsClearFilterTxt: 'Clear Filters',
        lsProfileFNameTxt: 'Firstname',
        lsProfileMNameTxt: 'Middlename',
        lsProfileLNameTxt: 'Lastname',
        lsProfileIDTxt: 'ID',
        lsProfileGenderTxt: 'Gender',
        lsTestDateTxt: 'Test Date',
        lsDateRangeTxt: 'Date Range',
        lsProfileLevelTxt: 'Level',
        lsProfileConussionTxt: 'Dr Dx Conussion',
        lsProfileNotifyEmailsTxt: 'Notify Email(s)',
        lsProfileNotifyPhonesTxt: 'Notify Phone(s)',
        lsOrgTxt: 'Organization',
        lsOrgsTxt: 'Organizations',
        lsManageUsrTxt: 'Manage Users',
        lsManageOrgTxt: 'Manage Organization',
        lsProfilePrintSelectTxt: 'Please select the way you want the profiles to be printed',
        lsProfilePrintWithTestTxt: 'with Tests',
        lsProfilePrintWithoutTestTxt: 'without Tests',
        lsProfileListPrintTxt: 'Print Profile List',
        lsCSVTxt: 'CSV',
        lsEditTxt: 'Edit',
        lsIDTxt: 'Id',
        lsViewProfileSportTxt: 'Sport(s)',
        lsViewProfileBDayTxt: 'Birthdate',
        lsViewProfileGenderTxt: 'Gender',
        lsViewProfileBaselineTxt: 'Baseline',
        lsViewProfileTotalTestTxt: 'Total Tests',
        lsViewProfileContactInfoTxt: 'Contact & Notify Info',
        lsViewProfileEmailTxt: 'Email',
        lsViewProfilePhoneTxt: 'Phone',
        lsViewProfileNotifyEmailTxt: 'Notify Email(s)',
        lsViewProfileNotifyPhonesTxt: 'Notify Phone(s)',
        lsViewProfileTestHistoryTxt: 'Test History',
        lsViewProfileShareTextTxt: 'Share Test',
        lsViewProfilePrintTxt : 'Print',
        lsViewProfileDownloadTxt: 'Download',
        lsViewProfileExportTxt: 'Export Profile List',
        lsViewProfileOkTxt: 'Ok',
        lsViewProfileTestExportSuccessTxt: 'Tests exported successfully!',        
        lsViewProfileTestSharedSuccessTxt: 'Tests shared successfully!',
        lsViewProfileTestShareFailTxt: 'Tests could not be shared.Please try again!',
        lsProfileListFilterTxt: 'Profile List Filter',
        lsFilterTxt: 'Filter',
        lsOkTxt: 'Ok',
        lsBaselineTxt: 'Baseline'
    },
    es: {
        lsHomeTxt: 'Casa',        
        lsProfilesTxt: 'Perfil',
        lsAddProfileTxt: 'Añadir perfil',
        lsUpldProfileTxt: 'Cargar nuevos perfiles',
        lsDnwldProfileTxt: 'Descargar',
        lsExportProfileOkTxt: 'De acuerdo',
        lsExportProfileSuccessTxt: '¡Perfiles exportados exitosamente sin pruebas!',
        lsProfilePrintTxt: 'Impresión',
        lsViewProfilesTxt: 'Ver perfiles',
        lsNoFilterTxt: 'No se aplicaron filtros',
        lsClearFilterTxt: 'Borrar filtros',
        lsProfileFNameTxt: 'Nombre de pila',
        lsProfileMNameTxt: 'Segundo nombre',
        lsProfileLNameTxt: 'Apellido',
        lsProfileIDTxt: 'CARNÉ DE IDENTIDAD',
        lsProfileGenderTxt: 'Género',
        lsTestDateTxt: 'Test Date',
        lsDateRangeTxt: 'Date Range',
        lsProfileLevelTxt: 'Nivel',
        lsProfileConussionTxt: 'Dr Dx Concussion',   
        lsProfileNotifyEmailsTxt: 'Notificar correo electrónico (s)',
        lsProfileNotifyPhonesTxt: 'Notificar teléfono (s)',        
        lsOrgTxt: 'Organización',
        lsOrgsTxt: 'Organizaciones',
        lsManageUsrTxt: 'Administrar usuarios',
        lsManageOrgTxt: 'Administrar organización',
        lsProfilePrintSelectTxt: 'Seleccione la forma en que desea que se impriman los perfiles',
        lsProfilePrintWithTestTxt: 'con Pruebas',
        lsProfilePrintWithoutTestTxt: 'sin pruebas',
        lsProfileListPrintTxt: 'Imprimir lista de perfiles',
        lsCSVTxt: 'CSV',
        lsEditTxt: 'Editar',
        lsIDTxt: 'Carné de identidad',
        lsViewProfileSportTxt: 'Deportes',
        lsViewProfileBDayTxt: 'Fecha de nacimiento',
        lsViewProfileGenderTxt: 'Género',
        lsViewProfileBaselineTxt: 'Base',
        lsViewProfileTotalTestTxt: 'Pruebas totales',
        lsViewProfileContactInfoTxt: 'Contacto y notificación de información',
        lsViewProfileEmailTxt: 'Email',
        lsViewProfilePhoneTxt: 'Teléfono',
        lsViewProfileNotifyEmailTxt: 'Notificar correo electrónico (s)',
        lsViewProfileNotifyPhonesTxt: 'Notificar teléfono (s)',
        lsViewProfileTestHistoryTxt: 'Historial de prueba',
        lsViewProfileShareTextTxt: 'Compartir prueba',
        lsViewProfilePrintTxt : 'Impresión',
        lsViewProfileDownloadTxt: 'Descargar',
        lsViewProfileExportTxt: 'Exportar lista de perfiles',
        lsViewProfileOkTxt: 'De acuerdo',
        lsViewProfileTestExportSuccessTxt: 'Pruebas exportadas con éxito',        
        lsViewProfileTestSharedSuccessTxt: '¡Pruebas compartidas exitosamente!',
        lsViewProfileTestShareFailTxt: 'Las pruebas no se pudieron compartir. ¡Inténtalo de nuevo!',
        lsProfileListFilterTxt: 'Filtro de lista de perfil',
        lsFilterTxt: 'Filtrar',
        lsOkTxt: 'Ok',
        lsBaselineTxt: 'Base'
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/profile/strings.profile.tsx